import {Component, computed, effect, inject, input, output, signal} from '@angular/core';
import {MaterialModule} from '../../../../../core/modules/material.module';
import {SharedModule} from '../../../../../core/modules/shared.module';
import {EventsService} from '../../../../../core/services/events.service';
import {DocumentComponent} from '../../../../../core/components/document/document.component';
import {ParticipantComponentNew} from '../participant/participant';
import {EventBlockComponentNew} from '../event-block/event-block.component';
import {EventDescriptionComponentNew} from '../event-block/event-description.component';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'event-detail-info',
  templateUrl: './event-detail-info.component.html',
  styleUrls: ['./event-detail-info.component.scss'],
  standalone: true,
  imports: [MaterialModule, SharedModule, DocumentComponent, EventBlockComponentNew,
    EventDescriptionComponentNew, ParticipantComponentNew
  ]
})

export class EventDetailInfoComponent {
  private eventService = inject(EventsService);
  private spinner = inject(NgxSpinnerService);

  eventData = input<any>();
  participantsLength = output<number>();
  id = computed(() => this.eventData().id);

  participants = signal<any>(null);
  participantCount = signal<number>(0);
  participantFriendCount = signal<number>(0);
  participantKeys = signal<number>(0);
  waitingListKeys = signal<number>(0);
  waitingList = signal<any>(null);
  waitlistCount = signal<number>(0);
  subEventWithBooking = signal<any>(null);
  constructor() {
    effect(() => {
      let id = this.id();
      if (id) {
        this.getParticipant(id);
        this.getSubEventForBooking();
      }
    });
  }

  getParticipant(id) {
    this.spinner.show();
    this.eventService.getParticipants(id).subscribe((res: any) => {
      if (res) {
        this.participants.set(res.participant);
        this.participantCount.set(res.participantCount);
        this.participantFriendCount.set(res.participantFriendCount);
        this.participantKeys.set(Object.keys(this.participants()).length);
        this.waitingList.set(res.waitingList);
        this.waitingListKeys.set(Object.keys(this.waitingList()).length);
        if (res.participant) {
          let length = Object.keys(this.participants()).reduce((acc, key) => acc + this.participants()[key].length, 0);
          this.participantsLength.emit(length);
        }
      }
      this.spinner.hide();
    });
  }

  updateParticipant() {
    this.getParticipant(this.id());
  }

  updateSubEvents() {
    this.getSubEventForBooking();
  }

  getSubEventForBooking() {
    this.spinner.show();
    this.eventService.getSubEventForBooking(this.id()).subscribe((res: any) => {
      if (res) {
        this.subEventWithBooking.set(res);
      }
      this.spinner.hide();
    });
  }

  setParticipantCount(event) {
    this.participantCount.set(event);
  }

  setWaitingListCount(event) {
    this.waitlistCount.set(event);
  }

  getSupportRequirements() {
    if (!this.eventData()?.documents) {
      return [];
    }
    return this.eventData().documents.filter(doc => doc.type === 'supportRequirements').map(doc => {
      return {
        ...doc,
        fileType: doc.name.split('.').pop()
      };
    });
  }

  getConditionsOfParticipation() {
    if (!this.eventData()?.documents) {
      return [];
    }
    return this.eventData().documents.filter(doc => doc.type === 'conditionsOfParticipation').map(doc => {
      return {
        ...doc,
        fileType: doc.name.split('.').pop()
      };
    });
  }

  getEventDocuments() {
    if (!this.eventData()?.documents) {
      return [];
    }
    return this.eventData().documents.filter(doc => doc.type === 'event').map(doc => {
      return {
        ...doc,
        fileType: doc.name.split('.').pop()
      };
    });
  }
}
